
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6c9fa241!postcss-loader!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SlideIndicator.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SlideIndicator.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6c9fa241!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SlideIndicator.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared-components/Slider/SlideIndicator.vue
// module id = 251
// module chunks = 0